import React, { useEffect, useState, useContext, useMemo } from 'react';
import UserContext, { StoreContext, UserProfileContext } from '../../../../common/utils/getContext';
import { getItemMenu } from '../../helpers';
import PropTypes from 'prop-types';
import SingleMenuItem from './components/SingleMenuItem/SingleMenuItem';
import { getRoute } from '../../../../common/utils/router';
import { useRouter } from 'next/router';
import GTCategories from '../../../../layouts/single/components/SingleHeader/components/GTCategories/GTCategories';

const SingleMenu = ({ isMobile, componentCss }) => {
    const { lang, menu } = useContext(UserContext);
    const [showSubMenu, setShowSubMenu] = useState(false);
    const [showSubMenuIdx, setShowSubMenuIdx] = useState(-1);

    const [categoriesGT, showCategoriesGT] = useState(false);

    const { roles = [] } = useContext(UserProfileContext) || {};
    const headerMenu = useMemo(() => getItemMenu(menu?.site, roles, lang), [roles, menu?.site, lang]);

    const router = useRouter();

    const [active, setActive] = useState(false);
    useEffect(() => {
        setActive(getRoute(router.asPath));
    }, [router]);

    // перевірка чи це сторінка магазину
    const isStorePage = useContext(StoreContext);

    return (
        <>
            {headerMenu.map((menuItem, idx) => {
                return (
                    <SingleMenuItem
                        key={idx}
                        {...{
                            setShowSubMenu,
                            setShowSubMenuIdx,
                            menuItem,
                            isMobile,
                            active,
                            componentCss,
                            showSubMenu,
                            idx,
                            showSubMenuIdx,
                            isStorePage,
                            showCategoriesGT
                        }}
                    />
                );
            })}
            {categoriesGT ? <GTCategories closeHandler={() => showCategoriesGT(false)} /> : null}
        </>
    );
};
SingleMenu.propTypes = {
    isMobile: PropTypes.bool,
    active: PropTypes.string,
    componentCss: PropTypes.object
};

export default SingleMenu;
